<template>
  <div
    class="@container mt-2 p-4 rounded-xl bg-gray-50 border-2 border-gray-200"
  >
    <div class="flex flex-col @4xl:flex-row gap-4">
      <div
        class="px-4 flex gap-2 @sm:gap-4 @4xl:gap-2 flex-col @sm:flex-row @4xl:flex-col items-center justify-center"
      >
        <ProfileImage
          custom-size-class="h-16 w-16 @4xl:h-32 @4xl:w-32"
          :person="agent"
        />
        <div class="text-center @sm:text-left @4xl:text-center">
          <div class="text-center text-4xl font-semibold text-gray-700">
            {{ agent.full_name }}
          </div>
          <div class="text-lg text-gray-600">({{ agent.alias }})</div>
        </div>
      </div>
      <StatBlock
        class="grow bg-white"
        label="Team Members"
        dense
        :loading="false"
      >
        <ul
          class="px-4 @xl:columns-2 @5xl:columns-3 gap-x-16 gap-y-2 text-left list-disc"
        >
          <li v-for="tm in agent.staff">
            <div class="font-semibold">
              {{ tm.full_name }}
            </div>
          </li>
        </ul>
      </StatBlock>
    </div>
  </div>
</template>

<script setup>
import ProfileImage from "@/components/ProfileImage.vue";
import StatBlock from "@/components/StatBlock.vue";

defineProps({
  agent: { type: Object, required: true },
});
</script>
